// App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/NavBar";
import Services from "./components/Services";
import Testimony from "./components/Testimony";
import AllServices from "./components/AllServices";
import ScrollToTop from "./components/scrollToTop";

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <section id="home">
                  <Home />
                </section>
                <section id="services">
                  <Services />
                </section>
                <section id="testimony">
                  <Testimony />
                </section>
                <section id="contact">
                  <Contact />
                </section>
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <AllServices />
              </>
            }
          />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
